import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { CardHeading } from "../profile/index.style";
import {
    ProfileHeading,
    ProfileAvatar,
    ProfileAvatarImg,
} from "./profileInfo.style";
import { Row, Column } from "../../global/grid";
import AdaHelper from "../../global/adaHelper";
import Panel, { PanelHeader, PanelBody } from "../../global/panel";
import Button from "../../global/button";
import ButtonLink from "../../global/buttonLink";
import SpiMasked from "../../global/spiMasked";
import ChangeNameModal from "../changeNameModal";
import EmailModal from "../emailModal";
import AddDniModal from "../addDniModal";
import ChangeEmploymentModal from "../changeEmploymentModal";

const ProfileInfo = ({ user }) => {
    const { t } = useTranslation("components.profile.profileInfo");
    const mainEmail = user.emails.find(e => e.principal)?.direccion;
    const mainPhone = user.telefonos.find(t => t.principal)?.numero;
    const changeNameModal = useRef(null);
    const addEmailModal = useRef(null);
    const addDniModal = useRef(null);
    const changeEmploymentModal = useRef(null);

    const changeName = () => {
        changeNameModal?.current && changeNameModal.current.open();
    };

    const addEmail = () => {
        addEmailModal?.current && addEmailModal.current.open();
    };

    const addDni = () => {
        addDniModal?.current && addDniModal.current.open();
    };

    const changeEmploymentData = () => {
        changeEmploymentModal?.current && changeEmploymentModal.current.open();
    };

    return (
        <Panel variant="shadowed">
            <PanelHeader>
                <CardHeading>{t("title")}</CardHeading>
            </PanelHeader>
            <PanelBody>
                <Row>
                    <Column md="4">
                        <ProfileAvatar>
                            <ProfileAvatarImg {...t("defaultUserPhoto", { returnObjects: true })} />
                        </ProfileAvatar>

                        {/*<ProfileAvatarLink onClick={linkVoid}>{t("updatePicture")}</ProfileAvatarLink>*/}
                    </Column>
                    <Column md="8">
                        <Row mt={{ _: 5, md: 0 }} mb={{ _: 5 }}>
                            <Column xs="6" md="12" xl="7" xxl="12">
                                <ProfileHeading>{user.nombres} {user.apellidos}</ProfileHeading>
                                <small>{t("memberSince")} {moment(user.fechaRegistro).format("YYYY")}</small>
                            </Column>
                            <Column xs="6" md="12" xl="5" xxl="12">
                                <Button colors="primary" size="sm" mt={3} onClick={changeName}>{t("changeName")}</Button>
                                <ChangeNameModal user={user} innerRef={changeNameModal}/>
                            </Column>
                        </Row>
                    </Column>
                </Row>
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" md="4" py={{ md: 3 }}>{t("email")}</Column>
                    <Column sm="12" md="8" py={{ md: 3 }}>
                        {mainEmail && <SpiMasked type="email">{mainEmail}</SpiMasked>}
                        {!mainEmail && <>
                            <ButtonLink onClick={addEmail}>
                                <span>{t("addEmail")}</span>
                                <AdaHelper>{t("addEmailAda")}</AdaHelper>
                            </ButtonLink>
                            <EmailModal isNewEmail email={{ principal: true }} innerRef={addEmailModal}/>
                        </>}
                    </Column>
                </Row>
                {mainPhone && (
                    <Row pb={{ _: 4, md: 0 }}>
                        <Column sm="12" md="4" py={{ md: 3 }}>{t("phone")}</Column>
                        <Column sm="12" md="8" py={{ md: 3 }}>
                            <SpiMasked type="phone">{mainPhone}</SpiMasked>
                        </Column>
                    </Row>
                )}
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" md="4" py={{ md: 3 }}>{t("dni")}</Column>
                    <Column sm="12" md="8" py={{ md: 3 }}>
                        {user.dni && <SpiMasked type="dni">{user.dni}</SpiMasked>}
                        {!user.dni && <>
                            <ButtonLink onClick={addDni}>
                                <span>{t("addDni")}</span>
                                <AdaHelper>{t("addDniAda")}</AdaHelper>
                            </ButtonLink>
                            <AddDniModal user={user} innerRef={addDniModal}/>
                        </>}
                    </Column>
                </Row>
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" md="4" py={{ md: 3 }}>{t("profession")}</Column>
                    <Column sm="12" md="8" py={{ md: 3 }}>{user.profesion}</Column>
                </Row>
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" md="4" py={{ md: 3 }}>{t("jobTitle")}</Column>
                    <Column sm="12" md="8" py={{ md: 3 }}>{user.cargo}</Column>
                </Row>
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" md="4" py={{ md: 3 }}>{t("employer")}</Column>
                    <Column sm="12" md="8" py={{ md: 3 }}>{user.empresa}</Column>
                </Row>
                <Row pb={{ _: 4, md: 0 }}>
                    <Column sm="12" py={{ md: 3 }}>
                        <ButtonLink onClick={changeEmploymentData}>{t("changeEmploymentInfo")}</ButtonLink>
                        <ChangeEmploymentModal user={user} innerRef={changeEmploymentModal}/>
                    </Column>
                </Row>
            </PanelBody>
        </Panel>
    );
};

export default ProfileInfo;
